import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchEmailConfigurationRequest } from 'shared/store/emailSettings/configuration'
import { getActiveClient } from 'shared/store/clients/selectors'
import { fetchEmailSignatureRequest } from 'shared/store/emailSettings/signature'
import useRolesAccess from './useRolesAccess'

const useInitEmailSettings = () => {
  const dispatch = useDispatch()
  const activeClient = useSelector(getActiveClient)
  const { hasOnlyAdvisorRole } = useRolesAccess()

  useEffect(() => {
    if (!activeClient?.id) return
    if (hasOnlyAdvisorRole) return

    dispatch(fetchEmailConfigurationRequest())
    dispatch(fetchEmailSignatureRequest())
  }, [activeClient?.id, dispatch, hasOnlyAdvisorRole])
}

export default useInitEmailSettings
